export const contactSupport = {
  support_title_message: "¡Contáctanos y  resolveremos juntos!",
  support_message: "Si necesitas ayuda o tienes alguna duda, nuestro equipo está listo para ayudarte.",
  support_modal_email: "Correo electrónico",
};
